import React from "react";
import moment from "moment";

function DateConverter({ date }) {
  const formatDate = (dateString) => {
    const [isoDate, desiredFormat] = date &&  dateString.split("/");
    const dateObj = moment.tz(moment(isoDate).format("YYYY-MM-DD"),global.config.getTimeZone()).toDate(); //new Date(isoDate);
    const options = { month: "long", day: "numeric", year: "numeric" };
    const formattedDate = dateObj.toLocaleDateString("en-US", options);
    return formattedDate;
  };

  return <>{ date && formatDate(date)}</>;
}

export default DateConverter;